<template>
	<div class="expensesheets-list-container">
		<v-row>
			<v-col cols="12" class="pt-0">
				<v-card v-for="item in items" :key="item.id"
				outlined
				class="mt-4">
					<v-card-text class="black--text">
						<h3 style="line-height: 24px; font-size: 1.2em;">{{ item.expenseDescription }}</h3>
						<v-row class="ma-0 pa-0">
							<v-col cols="12" class="pl-0 pb-0">
								<small class="d-block w-100" style="font-size: 14px; color: #424242">{{ $t('wkt.client.expensesheets.detail-window.items.ticket_date') }}</small>
								<span class="d-block w-100" style="font-size: 1.3em;">{{ formatLongDateTime(item.ticketDate) }}</span>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col cols="6" class="pl-0 pb-0">
								<small class="d-block w-100" style="font-size: 14px; color: #424242">{{ $t('wkt.client.expensesheets.detail-window.items.category') }}</small>
								<span class="d-block w-100 text-truncate" style="font-size: 1.3em;">{{ item.categoryName }}</span>
							</v-col>
							<v-col cols="6" class="pl-0 pb-0">
								<small class="d-block w-100" style="font-size: 14px; color: #424242">{{ $t('wkt.client.expensesheets.detail-window.items.format_type') }}</small>
								<span class="d-block w-100 text-truncate" style="font-size: 1.3em;">{{ getFormatTypeText(item.formatType) }}</span>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col cols="6" class="pl-0 pb-0">
								<small class="d-block w-100" style="font-size: 14px; color: #424242">{{ $t('wkt.client.expensesheets.detail-window.items.amount') }}</small>
								<span class="d-block w-100 red--text" style="font-size: 1.3em;">{{ formatCurrency(item.totalAmount) }}</span>
							</v-col>
							<v-col cols="6" class="pl-0 pb-0">
								<small class="d-block w-100" style="font-size: 14px; color: #424242">{{ $t('wkt.client.expensesheets.detail-window.items.payment_method') }}</small>
								<span class="d-block w-100 text-truncate" style="font-size: 1.3em;">{{ getPaymentMethodText(item.paymentMethod) }}</span>
							</v-col>
						</v-row>
						<v-row v-if="item.documentPath" class="ma-0">
							<v-col cols="12" class="pl-0 pb-0">
								<a class="text-decoration-underline text-truncate" @click.stop="$emit('download-document', item)">{{ item.documentName }}</a>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn v-if="[-1,2].includes(parent.status)" text color="#185EA9" class="text-button" @click.stop="$emit('edit-item', item)">{{ $t('wkt.client.expensesheets.detail-window.items.button-edit') }}</v-btn>
						<v-btn v-if="![-1,2].includes(parent.status)" text color="#185EA9" class="text-button" @click.stop="$emit('view-item', item)">{{ $t('wkt.client.expensesheets.detail-window.items.button-view') }}</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
	name: 'ExpenseSheetItemCardList',
	mixins: [BaseModule],
	props: ['parent','items'],
	components: {
	},
	data () {
		return { 
		}
    },
	methods: {
	},
}
</script>

